import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import VueSessionStorage from 'vue-sessionstorage'
import router from './router'
import store from './store'
import App from './App.vue'

import Maska from 'maska'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

Vue.use(VueSessionStorage)
Vue.config.productionTip = false

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

Vue.use(Maska)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
